import { describeFields } from '../common/fields';
import { PriceSchema } from './schemas';

export const PRICE_FIELDS = describeFields(PriceSchema, {
  priceId: {},
  label: {},
  terms: {},
  lessonsPerTerm: {},
  // A form shows the amount bare
  termPrice: { label: 'Term price ($)' },
  lessonPrice: { label: 'Lesson price ($)' },
  xeroCodes: {},
  active: {},
});
